<template>
  <div class="container">
    <div class="filter-container">
      <el-button
          class="filter-item"
          size="mini"
          type="primary"
          style="margin-bottom:10px"
          icon="el-icon-plus"
          @click="handleCreate"
      >添加活动</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="活动名称" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" align="center">
        <template v-slot="{row}">
          <span>{{ formatStartDate(row.DTStartDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center">
        <template v-slot="{row}">
          <span>{{ formatEndDate(row.DTEndDate) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="活动描述" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrDescription }}</span>
        </template>
      </el-table-column>

      <el-table-column label="创建人" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrCreatorName }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
    <el-dialog width="30%" :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false">
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="formModel"
          label-position="left"
          label-width="100px"
          style="margin-left:40px;"
          size="small"
      >
        <el-form-item label="活动名称" prop="StrName">
          <el-input v-model="formModel.StrName" placeholder="请输入活动名称" />
        </el-form-item>
        <el-form-item label="开始时间" prop="DTStartDate">
          <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="formModel.DTStartDate"
                style="width:100%"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                @change="choose"
            />
          </el-config-provider>
        </el-form-item>
        <el-form-item label="截止时间" prop="DTEndDate">
          <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="formModel.DTEndDate"
                style="width:100%"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                @change="choose"
            />
          </el-config-provider>
        </el-form-item>
        <el-form-item label="活动描述">
          <el-input v-model="formModel.StrDescription" placeholder="请输入活动描述" type="textarea"/>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <div style="float: right">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="btnAddorMod">确定</el-button>
        </div>
        <p style="color: #ffffff">三阅</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import {BASE_URL} from "@/utils/constants";

export default {
  name: 'Holiday',
  computed: {
    zhCn() {
      return zhCn;
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 1,
        OrderBy: { "DTCreatedDate": -1 },
        Search:{}
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      rules: {
        StrName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        DTStartDate: [
          {required: true, message: '请输入活动开始时间', trigger: 'change'}
        ],
        DTEndDate: [
          {required: true, message: '请输入活动结束时间', trigger: 'change'}
        ]
      },
      formModel: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** ---------- 安全日期解析 ---------- **/
    parseDateSafe(input) {
      if (!input) return null;
      if (input instanceof Date) return isNaN(input) ? null : input;

      let s = String(input).trim();
      if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/.test(s)) {
        s = s.replace(' ', 'T');
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        s = s + 'T00:00:00Z';
      }
      const m = /\/Date\((\d+)\)\//.exec(s);
      if (m) {
        const d = new Date(Number(m[1]));
        return isNaN(d) ? null : d;
      }
      const d = new Date(s);
      return isNaN(d) ? null : d;
    },

    choose() {
      if (!this.formModel.DTStartDate || !this.formModel.DTEndDate) return;
      const day1 = new Date(this.formModel.DTStartDate);
      const day2 = new Date(this.formModel.DTEndDate);
      if (day2.getTime() < day1.getTime()) {
        ElMessage.error('日期选择错误');
        this.formModel.DTEndDate = null; // 改为 null 而不是 ''
      }
    },

    formatStartDate(dateStr) {
      const date = this.parseDateSafe(dateStr);
      return date ? this.toLocalISO(date) : '-';
    },

    formatEndDate(dateStr) {
      const date = this.parseDateSafe(dateStr);
      return date ? this.toLocalISO(date) : '-';
    },

    toLocalISO(date) {
      if (!(date instanceof Date) || isNaN(date)) return '-';
      const formatter = new Intl.DateTimeFormat('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      const parts = formatter.formatToParts(date);
      const obj = Object.fromEntries(parts.map(p => [p.type, p.value]));
      return `${obj.year}-${obj.month}-${obj.day}`;
    },

    getList() {
      this.$axios({
        url: BASE_URL + 'readingactivity/search',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          this.listLoading = false;
        }
      });
    },

    handleCreate() {
      this.formModel = {};
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },

    toLocalISOString(date) {
      const pad = n => (n < 10 ? '0' + n : n);
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
      const offset = -date.getTimezoneOffset();
      const sign = offset >= 0 ? '+' : '-';
      const offsetHours = pad(Math.floor(Math.abs(offset) / 60));
      const offsetMinutes = pad(Math.abs(offset) % 60);
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${sign}${offsetHours}:${offsetMinutes}`;
    },

    btnAddorMod() {
      const parem = {
        StrDescription: this.formModel.StrDescription,
        StrName: this.formModel.StrName
      };
      const pattern = /^\d{4}-\d{2}-\d{2}$/;
      if (this.formModel.DTEndDate !== undefined && this.formModel.DTEndDate !== null) {
        if (pattern.test(this.formModel.DTStartDate) && pattern.test(this.formModel.DTEndDate)) {
          const now = new Date(); // 获取当前时间
          const dtStart = new Date(this.formModel.DTStartDate);
          dtStart.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds()); // 设置为当前时间
          const dtEnd = new Date(this.formModel.DTEndDate);
          dtEnd.setHours(23, 59, 59, 0);
          parem.DTStartDate = this.toLocalISOString(dtStart);
          parem.DTEndDate = this.toLocalISOString(dtEnd);
        }
      }
      if (this.dialogStatus === 'create') {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'readingactivity',
              method: 'put',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({message: '添加成功', type: 'success'});
              } else {
                this.$message({message: res.data.msg, type: 'error'});
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      } else {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'holidays/' + this.formModel.StrID,
              method: 'patch',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({message: '编辑成功', type: 'success'});
              } else {
                this.$message({message: res.data.msg, type: 'error'});
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      }
    },

    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    }
  }
};
</script>
